import { HourlyBonusState } from "./mainHourlyBonus/HourlyBonusState";

export enum HourlyBonusType {
    CHECKOUT = "CHECKOUT",
    MAIN = "MAIN"
}

export type HourlyBonusExecutionOptions<T extends HourlyBonusType> = {
    type: T,
    args: T extends HourlyBonusType.MAIN ? HourlyBonusState : { isWheel: boolean }
}